<div class="container" *ngIf="!loading()">
    <div class="header">
        <app-header></app-header>
    </div>
    <lib-breadcrumbs class="app-crumbs" [crumbs]="breadcrumbService.crumbs()"></lib-breadcrumbs>
    <div #content class="content">
        <router-outlet></router-outlet>
    </div>
</div>

<div toastContainer></div>
<app-glass-panel></app-glass-panel>
